export default "__VITE_ASSET__RyGGuhMz__"